export default "__VITE_ASSET__ec958716__"